import { render, staticRenderFns } from "./CodingSchemaList.vue?vue&type=template&id=0bc0d2a3&"
import script from "./CodingSchemaList.vue?vue&type=script&lang=js&"
export * from "./CodingSchemaList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports